import { Button, SparkleIcon } from '@iheartjane/reefer';

interface WizardButtonProps {
  label?: string;
  onClickStart: () => void;
}

export const WizardButton = ({
  label = 'Help me choose',
  onClickStart,
}: WizardButtonProps) => {
  return (
    <Button
      data-testid="wizard-button"
      label={label}
      onClick={onClickStart}
      startIcon={<SparkleIcon size="sm" />}
    />
  );
};
